var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 14,
    width: 14.519,
    viewBox: "0 0 25.064 30.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-bin",
    "data-name": "Icon metro-bin",
    fill: "#3c2f87",
    d: "M6.427,11.568v19.28a1.934,1.934,0,0,0,1.928,1.928H25.707a1.934,1.934,0,0,0,1.928-1.928V11.568H6.427Zm5.784,17.352H10.283v-13.5h1.928Zm3.856,0H14.139v-13.5h1.928Zm3.856,0H17.995v-13.5h1.928Zm3.856,0H21.851v-13.5h1.928ZM28.117,5.784H21.851V3.374a1.45,1.45,0,0,0-1.446-1.446H13.657a1.45,1.45,0,0,0-1.446,1.446v2.41H5.945A1.45,1.45,0,0,0,4.5,7.23V9.64H29.563V7.23a1.45,1.45,0,0,0-1.446-1.446Zm-8.194,0H14.139V3.88h5.784v1.9Z",
    transform: "translate(-4.499 -1.928)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.647d4ff92d99d26ceea17df374b61453.svg";
export { ForwardRef as ReactComponent };